"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPublicOfferId = void 0;
var regex_1 = require("@src/utils/regex");
var isPublicOfferId = function isPublicOfferId(id) {
    return regex_1.UUID_RE.test(id);
};
exports.isPublicOfferId = isPublicOfferId;
